import React, {memo, useEffect, useState, useCallback} from "react"
import {onClickHandler} from '../../../../../utils/onclick';

import './index.scss';
import {RawDevice} from '../../../../../store/setup/state';
import {useSelector, useDispatch} from "react-redux"
import {useOrientation} from '../../../../../hooks/orientation';
import {useRPC} from '../../../../../hooks/rpc';
import {useMessage} from '../../../../../hooks/message';
import {useLocalization} from "../../../../../hooks/localization";
import {setRSSIAction, setVersionAction} from "../../../../../store/control/actions"
type Props = {
    onClosePressed: () => void;
    rawDevice: RawDevice;
    deviceName: string;
    deviceImage: string;
};

function createNullArray(count) {
    if (!count) {
        return [];
    }

    return Array(count).fill(null);
}


const MatchedItemButton = memo(function MatchedItemButton({color, text, onClick, disabled}: { color: string; text: string; onClick: () => void; disabled?: boolean }) {
    const {t} = useLocalization();
    return (
        <div className={'matched-item-button ' + color} {...onClickHandler(disabled ? null : onClick)} >
            <span dangerouslySetInnerHTML={{__html: disabled ? t('searching') : text}}/>
        </div>
    );
});


export const SetupIOTestComponent = memo(function SetupIOTestComponent(props: Props) {
    const {
        onClosePressed,
        rawDevice,
        deviceName,
        deviceImage,
    } = props;
    const {t} = useLocalization();
    const [rpc] = useRPC();
    const {failure, success} = useMessage()
    const orientation = useOrientation();
    const deviceType = useSelector(state => state.control.bridgeDeviceTypeList.find(d => d.id === rawDevice.device_type_id));
    const dispatch = useDispatch()
    const [outputs, setOutputs] = useState<boolean[]>(createNullArray(deviceType?.output_count));
    const [inputs, setInputs] = useState<boolean[]>(createNullArray(deviceType?.input_count));
    const versionStatusControl = useSelector(state => state.control.versionStatus)
    const rssiStatus = useSelector(state => state.control.rssiStatus)

    useEffect(() => {
        if (versionStatusControl != null) {
            success(t("version") + ": " + versionStatusControl, true)
            dispatch(setVersionAction(null))
        }
    }, [success, versionStatusControl, t, dispatch])

    useEffect(() => {
        if (rssiStatus != null) {
            success(rssiStatus, true)
            dispatch(setRSSIAction(null))
        }
    }, [success, rssiStatus, t, dispatch])

    const outputClick = (slot: number) => {
        const newOutputs = outputs.map((o, i) => {
            if (i === slot) {
                return !o;
            }

            return o == null ? null : false;
        });
        rpc.setDirectOutput(rawDevice.gateway_id, rawDevice.unique_device_id, slot, newOutputs[slot] ? 1 : 0)
            .then(() => setOutputs(newOutputs))
            .catch(failure);
    };

    const inputClick = (slot: number) => {
        rpc.getDirectInput(rawDevice.gateway_id, rawDevice.unique_device_id, slot)
            .then((value) => setInputs(inputs => inputs.map((v, i) => {
                if (i === slot) {
                    return Boolean(value);
                }

                return v;
            })))
            .catch(failure);
    };

    const [dimmerTest, setDimmerTest] = useState(null);
    const dimOutputClick = () => {
        console.log('deneme')
        rpc.setDirectOutput(
            rawDevice.gateway_id,
            rawDevice.unique_device_id,
            (deviceType?.internal_type_id === 23 && 8) ||
                (deviceType?.internal_type_id === 4 && 4) ||
                (deviceType?.internal_type_id === 5 && 3), !dimmerTest ? 100 : 0
        ).then(() => setDimmerTest(p => !p))
    }

    useEffect(() => {
        setOutputs(createNullArray(deviceType?.output_count));
    }, [deviceType?.output_count]);

    useEffect(() => {
        setInputs(createNullArray(deviceType?.input_count));
    }, [deviceType?.input_count]);

    const versionClick = useCallback(() => {
        rpc.versionInfo(rawDevice.gateway_id, rawDevice.unique_device_id)
    }, [rpc, rawDevice.gateway_id, rawDevice.unique_device_id])

    const rssiClick = useCallback(() => {
        rpc.rssiInfo(rawDevice.gateway_id, rawDevice.unique_device_id)
    }, [rpc, rawDevice.gateway_id, rawDevice.unique_device_id])

    return (
        <div className={`io-test-modal ${orientation}`}>
            <div className='top'>
                <div className='left'>
                    <span className='title'>{t('io_test')}</span>
                    <img className='image' src={deviceImage} alt=''/>
                    <span className='name'>{deviceType?.name || '-'}</span>
                </div>
                <div className='middle'>
                    <div className='label-text-container'>
                        <span className='label'>
                            <span className='label-title'>{t('device_name')}:</span> {deviceName}
                        </span>
                    </div>
                    <div className='label-text-container'>
                        <span className='label'>
                            <span className='label-title'>{t('unique_id')}:</span> {rawDevice.unique_device_id}
                        </span>
                    </div>
                    {/*<div className='label-text-container'>*/}
                    {/*    <span className='label'><span className='label-title'>{t('VERSION')}:</span> 1.27</span>*/}
                    {/*</div>*/}
                    <div className='label-text-container'>
                        <span className='label'>
                            <span className='label-title'>{t('rf_power')}:</span> {rawDevice.rf_power.toString()}
                        </span>
                    </div>
                    <div className="iotest-button-container">
                        <MatchedItemButton
                            color='version'
                            text={t('version')}
                            onClick={versionClick}/>
                        <MatchedItemButton
                            color='rssi'
                            text={'RSSI'}
                            onClick={rssiClick}/>
                    </div>
                </div>
                <div className='right'>
                    <span className='close-text' {...onClickHandler(onClosePressed)}>{t('close')}</span>
                </div>
            </div>
            <div className='bottom'>
                <div className='inputs'>
                    {
                        inputs.map((state, i) => (
                            <div key={`input_${i}`} onClick={() => inputClick(i)}>
                                <span>{`IN${i}`}</span>
                                <div className={'input-button' + (state == null ? '' : (state ? ' green' : ' red'))}/>
                            </div>
                        ))
                    }
                </div>
                <div className='outputs'>
                    {
                        outputs.map((state, i) => (
                            <div key={`output_${i}`} onClick={() => outputClick(i)}>
                                <span>{`Q${i}`}</span>
                                <div className={'output-button' + (state == null ? '' : (state ? ' green' : ' red'))}/>
                            </div>
                        ))
                    }
                    {
                    renderIf(deviceType?.internal_type_id === 23 || deviceType?.internal_type_id === 4 || deviceType?.internal_type_id === 5)(() => (
                    <div onClick={dimOutputClick}>
                        <span>DIM</span>
                        <div className={"output-button" + (dimmerTest == null ? '' : (dimmerTest ? ' green' : ' red'))} />
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
});
